import React from "react";
import IFramePage from "../components/iFramePage";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageProps from "../lib/models/pageProps";
import { ServiceIncome } from "../lib/CmsApi";
import PageNotFoundError from "../lib/pageNotFoundError";

export default function Page(props: ServiceIncome) {
  return (
    <IFramePage
      src="https://apps.ifbhh.de/finanzass/modules/einkommensrechner"
      title={props.title}
      description={props.description}
      route="serviceIncome"
    />
  );
}

Page.getInitialProps = async ({
  api
}: InitialPropsContext): PageProps<ServiceIncome> => {
  const [seo] = await Promise.all([
    api.loadServiceIncome().catch(() => {
      throw new PageNotFoundError();
    })
  ]);
  return seo;
};
